import React, { createContext, useReducer, useContext } from "react";
import { data } from "../data/data";

//Define Conext
const GlobalStateContext = createContext();
const GlobalDispatchContext = createContext();

//Reducer
const globalReducer = (state, action) => {
  switch (action.type) {
    // case "TOGGLE_THEME": {
    //   return {
    //     ...state,
    //     currentTheme: action.theme,
    //   }
    // }
    case "CURSOR_TYPE": {
      return {
        ...state,
        cursorType: action.cursorType,
      };
    }
    case "SET_LOADING_STATE": {
      return {
        ...state,
        loading: action.loading,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

//Provider
export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(globalReducer, {
    // currentTheme:
    //   window.localStorage.getItem("theme") == null
    //     ? "dark"
    //     : window.localStorage.getItem("theme"),
    loading: true,
    data: data,
    cursorType: false,
    cursorStyles: ["pointer", "hovered", "clicked", "locked", "white"],
  });

  return (
    <GlobalDispatchContext.Provider value={dispatch}>
      <GlobalStateContext.Provider value={state}>
        {children}
      </GlobalStateContext.Provider>
    </GlobalDispatchContext.Provider>
  );
};

//Custom hooks for when we want to use our global state
export const useGlobalStateContext = () => useContext(GlobalStateContext);

export const useGlobalDispatchContext = () => useContext(GlobalDispatchContext);
